import { PostComposer } from '@pwa/components/posts/post-composer';
import { PostsFeed } from '@pwa/components/posts/posts-feed';
import { setPendingDraft } from '@pwa/lib/chat-store';
import { postQueries } from '@pwa/queries/posts';
import { useInfiniteQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { generateId } from 'better-auth';
import { useCallback } from 'react';

export const Route = createFileRoute('/_dashboard/org/$orgId/feed')({
	component: RouteComponent,
});

function RouteComponent() {
	const { orgId } = useParams({ from: Route.id });
	const navigate = useNavigate();

	const { data, isLoading, isError, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery(
		postQueries.feed(orgId),
	);
	const posts = data?.pages.flatMap((p) => p.posts) ?? [];

	const handleAskScout = useCallback(
		(body: string) => {
			const chatId = generateId(8);
			setPendingDraft(chatId, body);
			void navigate({
				to: '/org/$orgId/c/$chatId',
				params: { orgId, chatId },
			});
		},
		[navigate, orgId],
	);

	return (
		<div className='container mx-auto flex max-w-3xl flex-col gap-4 px-4 py-4 md:py-6'>
			<div className='flex flex-col gap-1'>
				<h2 className='text-base font-semibold text-foreground'>Feed</h2>
				<p className='text-xs text-muted-foreground'>Posts from across all workspaces.</p>
			</div>
			<PostComposer />
			<PostsFeed
				organizationId={orgId}
				posts={posts}
				isLoading={isLoading}
				isError={isError}
				isFetchingNextPage={isFetchingNextPage}
				hasNextPage={hasNextPage ?? false}
				onLoadMore={() => void fetchNextPage()}
				onAskScout={handleAskScout}
			/>
		</div>
	);
}
